//eslint-disable import/first

import React from 'react';
import ConsultantItem from './ConsultantItem';

import { FixedSizeList as List } from 'react-window';

const moment = require('moment');

class ConsultantList extends React.Component {

  render() {
    return (
      <ul id="consultants-list" className="list">
        <List
          height={window.innerHeight - 180}
          itemCount={this.props.displayConsultants.length}
          itemSize={32}
          width="100%"
        >
        {({ index , style }) => (
          <div style={style}>
            <ConsultantItem
              key={this.props.displayConsultants[index]._id}
              lastname={this.props.displayConsultants[index].user.sageContent.profile.lastName}
              firstname={this.props.displayConsultants[index].user.sageContent.profile.firstName}
              projects={this.props.displayConsultants[index].projects}
              user={this.props.user}
              consultant={this.props.displayConsultants[index]}
              id={this.props.displayConsultants[index]._id}
              timestamp={moment(this.props.displayConsultants[index].createdAt).from(moment())}
              translate = {this.props.translate}
          />
        </div>)}
        </List>
      </ul>
    );
  }
}

export default ConsultantList;
